import React, { useCallback, useState } from 'react';

type PriceAlertModalContextType = Readonly<{
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}>;

const PriceAlertModalContext = React.createContext<PriceAlertModalContextType | undefined>(undefined);

export const usePriceAlertModal = () => {
  const context = React.useContext(PriceAlertModalContext);
  if (!context) {
    throw new Error('usePriceAlertModal must be used within a PriceAlertModalProvider');
  }
  return context;
};

export const PriceAlertModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onOpen = useCallback(() => setIsOpen(true), []);
  const onClose = useCallback(() => setIsOpen(false), []);

  const value = React.useMemo(
    () => ({
      isOpen,
      onOpen,
      onClose,
    }),
    [isOpen, onOpen, onClose],
  );

  return <PriceAlertModalContext.Provider value={value}>{children}</PriceAlertModalContext.Provider>;
};
